<template>
    <div class="content-container">
        <NavbarPublicCobre />
        <div class="background-zone">
            <v-row>
                <v-col cols="12" class="text-end">
                    <button class="logout-button" @click="logOut">Cerrar sesión X</button>
                </v-col>
            </v-row>
            <v-row class="text-start ml-6 mt-4 mb-2">
                <v-col cols="12">
                    <h1 class="text-white font-weight-bold">
                        Investors
                    </h1>
                </v-col>
            </v-row>
        </div>
        <v-container fluid class="container-data">
            <v-row class="text-start ml-4 mt-4 mb-2">
                <!-- Categorías -->
                <v-col cols="12" md="3" class="border-end">
                    <v-divider class="custom-divider" />
                    <v-btn variant="text" class="categorys" :class="{
                        'selected_category active font-weight-bold': selectedPage === 'news',
                    }" style="justify-content: flex-start" block>
                        News
                    </v-btn>
                    <v-divider class="custom-divider" />
                    <v-btn variant="text" class="categorys" :class="{
                        'selected_category font-weight-bold': selectedPage === 'files',
                    }" style="justify-content: flex-start" @click="changePageFiles('Offering Memorandum')" block>
                        Offering Memorandum
                    </v-btn>
                    <v-divider class="custom-divider" />
                    <v-btn variant="text" class="categorys" :class="{
                        'selected_category font-weight-bold': selectedPage === 'files',
                    }" style="justify-content: flex-start" @click="changePageFiles('Financial Statements')" block>
                        Financial Statements
                    </v-btn>
                    <v-divider class="custom-divider" />
                    <v-btn v-if="selectedPage" size="x-small" variant="text" class="text-cleaner"
                        @click="selectedPage = null">
                        Limpiar categoría
                    </v-btn>
                </v-col>

                <!-- Años -->
                <v-col cols="12" md="2" class="border-end" v-if="selectedPage === 'news'">
                    <v-divider class="custom-divider" />
                    <v-radio-group v-model="selectedYear" column>
                        <v-radio v-for="year in years" :key="year.year" :label="year.year" :value="year.year"
                            class="my-2 custom-radio"
                            :class="{ 'custom-radio--selected': selectedYear === year.year }" />
                    </v-radio-group>
                    <v-btn v-if="selectedYear" size="x-small" variant="text" class="text-cleaner"
                        @click="selectedYear = null">
                        Limpiar año
                    </v-btn>
                </v-col>


                <!-- Archivos -->
                <v-col cols="12" md="5" v-if="selectedYear">
                    <v-list two-line>
                        <v-list-item v-for="item in newsContent" :key="item.file_name" @click="seeMore(item)"
                            class="hoverable">
                            <v-row no-gutters>
                                <v-col cols="1" class="d-flex justify-end align-start">
                                    <div v-if="expandedItem === item">
                                        <img src="../../../assets/flechita-cobre.svg" width="24" alt="" />
                                    </div>
                                    <div v-else>
                                        <img src="../../../assets/flechita-cobre-up.svg" width="24" alt="" />
                                    </div>
                                </v-col>
                                <v-col cols="11">
                                    <v-list-item class="d-flex align-center">
                                        <v-list-item-content class="py-1">
                                            <v-list-item-title class="font-weight-bold">
                                                {{ item.title }}
                                            </v-list-item-title>
                                            <div v-if="expandedItem === item" >
                                                <div v-html="item.description"></div>
                                                <div class="custom-divider-two"></div>
                                            </div>


                                        </v-list-item-content>
                                    </v-list-item>
                                </v-col>
                            </v-row>
                        </v-list-item>
                    </v-list>
                </v-col>
            </v-row>
        </v-container>
        <FooterCobre />
    </div>
</template>

<script setup>
import { ref, onMounted, watch, computed } from "vue";
import { getNewsForInvestors } from "../services/news-service";
import router from "@/router";
import FooterCobre from "@/components/FooterCobre.vue";
import NavbarPublicCobre from "@/components/NavbarPublicCobre.vue";

const news = ref({ content: [] });
const originalNews = ref([]);
const itemsPerPage = ref(3000);
const loading = ref(false);
const expandedItem = ref(null);

const selectedYear = ref(null);

const years = ref([]);

const newsContent = computed(() => news.value.content);

const loadItems = async () => {
    loading.value = true;
    try {
        const params = { page: 0, size: itemsPerPage.value };
        const result = await getNewsForInvestors(params);
        if (result && result.status === 200) {
            originalNews.value = result.data;
            news.value.content = result.data;
            updateFilteredData();
        }
    } catch (error) {
        console.error("Error al cargar archivos:", error);
    } finally {
        loading.value = false;
    }
};

const updateFilteredData = () => {
    // Generar todos los años y títulos posibles antes de filtrar
    const allYears = [...new Set(originalNews.value.map((f) => f.year))].sort((a, b) => b - a);
    years.value = allYears.map((y) => ({ year: y }));

    // Ahora sí aplicar filtros
    const filtered = originalNews.value.filter((file) => {
        const matchesYear = !selectedYear.value || file.year === selectedYear.value;
        return matchesYear;
    });

    news.value.content = filtered;
};

const seeMore = (item) => {
    expandedItem.value = expandedItem.value === item ? null : item;
};

const selectedPage = ref('news');

const changePageFiles = async (category) => {
    await router.push({ name: "list-files-investors", query: { category: category } });
};

const logOut = () => {
    localStorage.removeItem("token");
    router.push({ name: "admin" });
};

onMounted(() => {
    loadItems();
});

watch(selectedYear, () => {
    updateFilteredData();
});
</script>

<style scoped>
:deep(*) {
    font-family: "Now", sans-serif !important;
}

h1 {
  position: relative;
  display: inline-block;
  font-size: 2.5rem;
  line-height: 2.5rem;
  font-weight: bold;
  font-family: 'Now';
  color: white;
  z-index: 1;
}

h1::before {
  content: '';
  position: absolute;
  bottom: 0.2rem; /* cerca de la base del texto */
  left: 0;
  width: 100%; /* que cubra todo el texto */
  height: 1rem; /* menos alto para parecer subrayado */
  background-color: rgba(241, 90, 41, 0.6);
  z-index: -1;
}


.hoverable {
    transition: background-color 0.2s ease;
}

.hoverable:hover {
    background-color: #f5f5f5;
}

.content-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.container-data {
  flex: 1;
}

.background-zone {
    height: 18rem;
    width: 100%;
    background-image: url("../../../assets/mine2.jpg");
    background-size: cover;
    background-position: center;
}

.custom-divider {
    background-color: #000000 !important;
    height: 10px !important;
    opacity: 1 !important;
}

.custom-divider-two {
    background-color: #000000 !important;
    height: 1px !important;
    opacity: 1 !important;
    margin-top: 1rem !important;
}

.text-cleaner {
    color: #df6439 !important;
    font-size: 0.6rem !important;
}

.categorys {
    font-weight: bold;
    font-size: 1rem;
}

.selected_category {
    background-color: white !important;
    color: #df6439 !important;
    font-weight: bold !important;
    font-size: 1rem;
}

:deep(.custom-radio .v-icon.mdi-radiobox-blank) {
    color: grey !important;
}

:deep(.custom-radio .v-icon.mdi-radiobox-marked) {
    color: #df6439 !important;
    font-weight: bold !important;
}

:deep(.custom-radio .v-label) {
    font-weight: bold !important;
    color: grey !important;
}

:deep(.custom-radio--selected .v-label) {
    color: black !important;
    opacity: 1 !important;
}


.logout-button {
    background-color: #df6439;
    border: none;
    color: white;
    font-weight: bold;
    font-size: 1rem;
    cursor: pointer;
    margin-top: 128px;
    margin-right: 32px;
    padding-left: 16px;
    padding-right: 16px;
    padding-top: 8px;
    padding-bottom: 8px;
}

.logout-button:hover {
    background-color: darken(#df6439, 60%);
}

</style>